/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    padding: "5px",
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    },
    overflow: "hidden",
  },
  cardContainerWithoutPadding: {
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    },
    overflow: "hidden",
  },
  estimationCardContainer: {
    height: "502px",
    margin: "10px 5px 0px 5px",
    overflow: "hidden",
  },
  estimationCardContainerPricing: {
    height: "603px",
    margin: "10px 5px 0px 5px",
    overflow: "hidden",
  },
  estimationCardContainerDailyPromotions: {
    height: "633px",
    margin: "10px 5px 0px 5px",
    overflow: "hidden",
  },
  card: {
    height: "100%",
    padding: "10px 20px 10px 20px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "5px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
  },
  estimationCard: {
    height: "100%",
    // padding: "10px 20px 10px 20px",
    margin: "0px 5px 0px 5px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "5px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
  },
  styleCard: {
    height: "170px",
    padding: "10px 20px 10px 20px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "5px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
  },
  styleCardCompetitors: {
    // padding: "30px 30px 30px 30px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "5px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
  },
  styleCardImportCsv: {
    height: "95px",
    padding: "10px 20px 10px 20px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "5px",
    backgroundColor: "#EEEEEE",
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    marginBottom: "5px",
    fontWeight: "bold",
    alignItems: "center",
    justifyContent: "space-between",
  },
  estimationcardHeader: {
    fontWeight: "bold",
    alignItems: "start",
    justifyContent: "space-between",
  },
  cardRow: {
    display: "flex",
    marginBottom: "15px",
    justifyContent: "space-around",
    alignItems: "center",
  },
  cardRowItem: {
    flex: "50%",
  },
}));

function CardComponent({
  title,
  body,
  styleCard = false,
  styleCardImportCsv = false,
  withoutPadding = false,
  estimationCardContainer = false,
  isDailyPromotions = false,
  isAnnualPricing = false,
  customStyle = null,
  isCompetitors = false,
}) {
  const classes = useStyles();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const classCustomCard = styleCard ? classes.styleCard : classes.card;
  const classCardImportCsv = styleCardImportCsv
    ? classes.styleCardImportCsv
    : classes.card;
  const isCustomCard = styleCard ? classCustomCard : classCardImportCsv;
  const isCardCompetitors = isCompetitors
    ? classes.styleCardCompetitors
    : isCustomCard;
  const card = isSmallScreen ? classes.card : isCardCompetitors;
  const isPadding = withoutPadding
    ? classes.cardContainerWithoutPadding
    : classes.cardContainer;

  return (
    <div
      className={clsx({
        [isPadding]: estimationCardContainer !== true,
        [classes.estimationCardContainerDailyPromotions]:
          isDailyPromotions === true,
        [classes.estimationCardContainerPricing]: isAnnualPricing === true,
        [classes.estimationCardContainer]: estimationCardContainer,
        [customStyle]: customStyle,
      })}
    >
      <div
        className={clsx({
          [card]: estimationCardContainer !== true,
          [classes.estimationCard]: estimationCardContainer,
        })}
      >
        {title && (
          <div
            className={clsx({
              [classes.cardHeader]: estimationCardContainer !== true,
              [classes.estimationcardHeader]: estimationCardContainer,
            })}
          >
            {title}
          </div>
        )}
        {body}
      </div>
    </div>
  );
}

export default CardComponent;
